"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react');



var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _useBus = require('shared/hooks/useBus'); var _useBus2 = _interopRequireDefault(_useBus);
var _campaignRecipientsAdds = require('shared/selectors/campaignRecipientsAdds');
var _hooks = require('web/services/hooks');
var _format = require('./format');

/* P2': while a background Add runs, the server refuses sending (Send now,
 * Schedule, Resume), variable changes and archiving; the page disables them
 * with this reason. */
 const WAIT_FOR_ADD_REASON = 'Wait for recipients to finish adding'; exports.WAIT_FOR_ADD_REASON = WAIT_FOR_ADD_REASON

/* …and another Add into the same campaign. */
 const ADD_RUNNING_REASON = 'Recipients are already being added to this campaign'; exports.ADD_RUNNING_REASON = ADD_RUNNING_REASON

 const useIsAddingRecipients = (campaignKey) =>
  _hooks.useAppSelector.call(void 0, state => !!campaignKey && _campaignRecipientsAdds.selectIsAddingRecipients.call(void 0, state, campaignKey)); exports.useIsAddingRecipients = useIsAddingRecipients

 const useRecipientsAdd = (campaignKey) =>
  _hooks.useAppSelector.call(void 0, state => campaignKey ? _campaignRecipientsAdds.selectCampaignRecipientsAdd.call(void 0, state, campaignKey) : null); exports.useRecipientsAdd = useRecipientsAdd

/* The starter's notice once the server has taken a background Add. */
 const addStartedNotice = (count) =>
  `Adding ${_format.pluralize.call(void 0, count, 'recipient', 'recipients')}. This keeps going if you leave this page.`; exports.addStartedNotice = addStartedNotice



/* The fixed wording for an Add that ended before its last row. */
 const addStoppedText = (add) =>
  `Adding stopped after ${_format.formatCount.call(void 0, add.RowsDone)} of ${_format.formatCount.call(void 0, add.TotalRows)} rows. Add the same file again to finish.`; exports.addStoppedText = addStoppedText

 const addFailedText = (add) =>
  `Adding failed after ${_format.formatCount.call(void 0, add.RowsDone)} of ${_format.formatCount.call(void 0, add.TotalRows)} rows. ` +
  'Something went wrong while saving recipients. ' +
  `${_format.pluralize.call(void 0, add.Added, 'recipient was', 'recipients were')} added. Add the same file again to finish.`; exports.addFailedText = addFailedText

/* The starter's notice when the Add ends (from the complete push). */
 const addFinishedNotice = (add, campaignName) =>
  add.State === 'finished'
    ? { type: 'success' , text: `Added ${_format.pluralize.call(void 0, add.Added, 'recipient', 'recipients')} to ${campaignName}.` }
    : add.State === 'failed'
      ? { type: 'warning' , text: exports.addFailedText.call(void 0, add) }
      : { type: 'warning' , text: exports.addStoppedText.call(void 0, add) }; exports.addFinishedNotice = addFinishedNotice

// Some engines put a narrow no-break space before AM/PM; JS \s covers it.
const plainSpaces = (s) => s.replace(/\s/g, ' ')

/* "2:14 PM" today, "Oct 13, 2:14 PM" another day. */
 const formatStartedAt = (iso, now = new Date()) => {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  const isToday = date.toDateString() === now.toDateString()
  return plainSpaces(new Intl.DateTimeFormat('en-US', {
    month: isToday ? undefined : 'short',
    day: isToday ? undefined : 'numeric',
    year: date.getFullYear() === now.getFullYear() ? undefined : 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(date))
}; exports.formatStartedAt = formatStartedAt

 const startedByText = (add) =>
  `Started by ${add.StartedByName} · ${exports.formatStartedAt.call(void 0, add.StartedAt)}`; exports.startedByText = startedByText

const RECONNECTED = ['SERVER_ACK_SOCKET_CONNECTED']

/* Reads the campaigns' latest background Adds when they show (a campaign
 * page, the wizard, the campaign list) and again after a reconnect, which
 * may have missed pushes. Pushes keep them current in between. An older
 * server without the command leaves the store as it is. */
 const useLoadRecipientsAdds = (campaignKeys) => {
  const keysId = campaignKeys.join(',')
  const keys = _react.useMemo.call(void 0, () => keysId ? keysId.split(',')  : [], [keysId])
  const load = _react.useCallback.call(void 0, 
    () => { if (keys.length) _actions2.default.getCampaignRecipientsAdds(keys).catch(() => undefined) },
    [keys],
  )
  _react.useEffect.call(void 0, load, [load])
  _useBus2.default.call(void 0, RECONNECTED, load)
}; exports.useLoadRecipientsAdds = useLoadRecipientsAdds
